'use strict';

exports.__esModule = true;
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _canUseDom = require('can-use-dom');

var _canUseDom2 = _interopRequireDefault(_canUseDom);

var _Facebook = require('./Facebook');

var _FacebookProvider = require('./FacebookProvider');

var _FacebookProvider2 = _interopRequireDefault(_FacebookProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Login = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Login, _Component);

  function Login() {
    var _this2 = this;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Login);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {}, _this.onClick = function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(evn) {
        var _this$state, facebook, isWorking, _this$props, scope, fields, onError, onResponse, returnScopes, rerequest, loginQpts, response, data;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                evn.stopPropagation();
                evn.preventDefault();

                _this$state = _this.state, facebook = _this$state.facebook, isWorking = _this$state.isWorking;

                if (!(!facebook || isWorking)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return');

              case 5:

                _this.setState({
                  isWorking: true
                });

                _this$props = _this.props, scope = _this$props.scope, fields = _this$props.fields, onError = _this$props.onError, onResponse = _this$props.onResponse, returnScopes = _this$props.returnScopes, rerequest = _this$props.rerequest;
                loginQpts = { scope: scope };


                if (returnScopes) {
                  loginQpts.return_scopes = true;
                }

                if (rerequest) {
                  loginQpts.auth_type = 'rerequest';
                }

                _context.prev = 10;
                _context.next = 13;
                return facebook.login(loginQpts);

              case 13:
                response = _context.sent;

                if (!(response.status !== 'connected')) {
                  _context.next = 16;
                  break;
                }

                throw new Error('Unauthorized user');

              case 16:
                _context.next = 18;
                return facebook.getTokenDetailWithProfile({ fields: fields });

              case 18:
                data = _context.sent;


                _this.setState({
                  isWorking: false,
                  data: data,
                  error: null
                });

                if (onResponse) {
                  onResponse(data);
                }
                _context.next = 27;
                break;

              case 23:
                _context.prev = 23;
                _context.t0 = _context['catch'](10);

                _this.setState({
                  isWorking: false,
                  data: null,
                  error: _context.t0
                });

                if (onError) {
                  onError(_context.t0);
                }

              case 27:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[10, 23]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Login.prototype.componentDidMount = function componentDidMount() {
    if (_canUseDom2.default) {
      this.initFacebook();
    }
  };

  Login.prototype.initFacebook = function () {
    var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
      var facebook, onReady;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.context.facebook.init();

            case 2:
              facebook = _context2.sent;


              this.setState({
                facebook: facebook
              });

              onReady = this.props.onReady;

              if (onReady) {
                onReady();
              }

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function initFacebook() {
      return _ref2.apply(this, arguments);
    }

    return initFacebook;
  }();

  Login.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        render = _props.render,
        Component = _props.component;
    var _state = this.state,
        error = _state.error,
        data = _state.data,
        facebook = _state.facebook,
        _state$isWorking = _state.isWorking,
        isWorking = _state$isWorking === undefined ? false : _state$isWorking;

    var isLoading = !facebook;

    if (render) {
      return render({
        isLoading: isLoading,
        isWorking: isWorking,
        data: data,
        error: error,
        onClick: this.onClick
      });
    }

    if (Component) {
      return _react2.default.createElement(Component, {
        isLoading: isLoading,
        isWorking: isWorking,
        data: data,
        error: error,
        onClick: this.onClick
      });
    }

    return (0, _react.cloneElement)(children, {
      isLoading: isLoading,
      isWorking: isWorking,
      data: data,
      error: error,
      onClick: this.onClick
    });
  };

  return Login;
}(_react.Component), _class.propTypes = {
  scope: _propTypes2.default.string.isRequired,
  fields: _propTypes2.default.array.isRequired,
  onError: _propTypes2.default.func.isRequired,
  onResponse: _propTypes2.default.func.isRequired,
  onReady: _propTypes2.default.func,
  children: _propTypes2.default.node,
  render: _propTypes2.default.func,
  returnScopes: _propTypes2.default.bool,
  rerequest: _propTypes2.default.bool,
  component: _propTypes2.default.node
}, _class.contextTypes = (0, _extends3.default)({}, _FacebookProvider2.default.childContextTypes), _class.defaultProps = {
  scope: '',
  fields: ['id', 'first_name', 'last_name', 'middle_name', 'name', 'email', 'locale', 'gender', 'timezone', 'verified', 'link'],
  returnScopes: false,
  rerequest: false,
  onReady: undefined,
  children: undefined,
  render: undefined,
  component: undefined
}, _temp2);
exports.default = Login;


//////////////////
// WEBPACK FOOTER
// ./~/react-facebook/lib/Login.js
// module id = 687
// module chunks = 1